import type { Device } from '../lib/devices';
import styles from './Legend.module.css';

/** Props for {@link Legend}. */
export interface LegendProps {
  devices: readonly Device[];
  hidden: ReadonlySet<string>;
  onToggle: (deviceId: string) => void;
}

/** One toggle per device that shows or hides its line on every chart; a hidden device is greyed out. */
const Legend = ({ devices, hidden, onToggle }: LegendProps) => (
  <div className={styles.legend} role='group' aria-label='Devices'>
    {devices.map((device) => (
      <button
        key={device.id}
        type='button'
        className={styles.item}
        aria-pressed={!hidden.has(device.id)}
        onClick={() => onToggle(device.id)}
      >
        <span
          className={styles.swatch}
          style={
            hidden.has(device.id)
              ? undefined
              : { backgroundColor: device.color }
          }
        />
        {device.label}
      </button>
    ))}
  </div>
);

export default Legend;
